import { Component, OnInit } from '@angular/core';
import { SidebarService } from '@ibe/services/ui';

@Component({
	selector: 'app-booking-extras-rent-a-car',
	templateUrl: './booking-extras-rent-a-car.component.html',
	styleUrls: ['./booking-extras-rent-a-car.component.scss']
})
export class BookingExtrasRentACarComponent implements OnInit {

	constructor(
		private sidebarService: SidebarService,
	) { }

	ngOnInit() {
	}

	// SIDEBAR INTERACTIONS

	/** Close sidebar and clear secondary route */
	TAP_handleClose() {
		this.sidebarService.closeSidebar();
	}

}
